import React, { memo } from 'react';
import { useSecondTick } from '../../hooks/useSecondTick';

const SYNC_CYCLE_MS = 120_000;

type Props = {
  lastUpdate: number;
  isFa: boolean;
};

/** Header “last update” time + 2‑minute sync progress bar; isolated 1s re-renders only. */
export const HeaderLastUpdateBlock = memo(function HeaderLastUpdateBlock({ lastUpdate, isFa }: Props) {
  const now = useSecondTick();
  const refreshBarRemaining = Math.max(0, 1 - Math.min(1, (now - lastUpdate) / SYNC_CYCLE_MS));

  return (
    <div className="flex flex-col items-end min-w-0">
      <span className="text-xs uppercase tracking-wider text-ir-faint font-sans hidden sm:block">
        {isFa ? 'آخرین به‌روزرسانی' : 'Last update'}
      </span>
      <time
        className="font-mono text-sm sm:text-base text-ir-text tabular-nums font-medium"
        dateTime={new Date(lastUpdate).toISOString()}
      >
        {new Date(lastUpdate).toLocaleTimeString(isFa ? 'fa-IR' : 'en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
          timeZone: 'UTC',
        })}{' '}
        <span className="text-ir-faint text-xs sm:text-sm font-normal">UTC</span>
      </time>
      <div
        className="mt-1 h-1 w-[8.5rem] max-w-[42vw] bg-ir-border overflow-hidden rounded-none"
        title={isFa ? 'زمان تا به‌روزرسانی بعدی داده' : 'Time until next data refresh'}
      >
        <div
          className="h-full bg-ir-blue transition-[width] duration-700 ease-linear"
          style={{ width: `${refreshBarRemaining * 100}%` }}
        />
      </div>
    </div>
  );
});
